// Anita Week 7 / Day 2 — Работа и расписание / Work and Schedule
// U.S. Grade 3 upgrade for Week 7 Day 2.

const day2 = {
  id: 'day-2',
  studentId: 'anita',
  weekId: 'week-7',
  dayId: 'day-2',
  status: 'active',
  title: 'Работа и расписание / Work and Schedule',
  shortTitle: 'Расписание работы / Work Schedule',
  theme: 'Анита учится, как мастер планирует работу. / Anita learns how a master plans work.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'business-thinking', 'schedule', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни показывает Аните расписание мастера. / Nimny shows Anita a master schedule.',
  goals: [
    'Понять слова: работа, расписание, чинить.',
    'Решить задачи Grade-3: умножение, сложение, вычитание, деление.',
    'Провести логику: с чего начать.',
    'Написать слова и объяснить родителю.'
  ],
  vocabulary: [
    { term: 'работа / work', definition: 'дело, которое человек выполняет. / a task a person performs.' },
    { term: 'расписание / schedule', definition: 'список дел по времени. / list of tasks by time.' },
    { term: 'чинить / to fix', definition: 'делать поломанное снова рабочим. / make something broken work again.' },
    { term: 'порядок / order', definition: 'когда дела идут по шагам. / when tasks go step by step.' },
    { term: 'план / plan', definition: 'заранее записанные шаги. / steps written down ahead.' },
    { term: 'время / time', definition: 'сколько длится дело. / how long a task takes.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы',
      prompt: 'Прочитай по-русски:\nработа\nрасписание\nчинить\nпорядок\nплан\nвремя',
      ruPrimaryText: 'Прочитай 6 слов.', enHelpText: 'Read 6 words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение',
      prompt: 'Прочитай по-русски:\nМастер умеет чинить.\nРасписание помогает не забыть дело.\nПорядок делает работу быстрее.\nПлан — это шаги.',
      ruPrimaryText: 'Прочитай 4 фразы.', enHelpText: 'A master knows how to fix. A schedule helps.', answer: 'Попытка чтения.' },
    { id: 'master-5-things', type: 'text', title: 'Задание 3 — Мастер и 5 вещей',
      prompt: 'Мастер должен чинить 5 вещей.\nКаждая вещь занимает 8 минут.\nПотом мастер тратит 10 минут на уборку.\n\nОтветь:\n1. Сколько минут чинит?\n2. Сколько минут всего с уборкой?',
      ruPrimaryText: 'Реши по шагам (математика Grade 3).', enHelpText: 'Math: multi-step.', answer: '8 × 5 = 40; 40 + 10 = 50 минут.' },
    { id: 'schedule-4-tasks', type: 'text', title: 'Задание 4 — Расписание из 4 дел',
      prompt: 'В расписании 4 дела: 6 мин, 12 мин, 25 мин и 7 мин.\nЧас — это 60 минут.\n\nОтветь:\n1. Сколько минут всего?\n2. Сколько минут свободных за час?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Multi-step sum.', answer: '6 + 12 + 25 + 7 = 50; 60 − 50 = 10 минут.' },
    { id: 'three-days-5-tasks', type: 'text', title: 'Задание 5 — 3 дня по 5 дел',
      prompt: 'В каждый день Анита делает 2 утренних дела и 3 вечерних.\nВсего дней — 3.\n\nОтветь:\n1. Сколько дел в один день?\n2. Сколько дел за 3 дня?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Grade-3 multi-step.', answer: '2 + 3 = 5; 5 × 3 = 15 дел.' },
    { id: 'work-48-minutes', type: 'text', title: 'Задание 6 — 48 минут работы',
      prompt: 'У Аниты 48 минут на работу помощника.\n1/2 — уборка, 1/4 — чтение, остальное — отдых.\n\nОтветь:\n1. Сколько на уборку?\n2. Сколько на чтение?\n3. Сколько на отдых?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Multi-step fractions.', answer: '48 ÷ 2 = 24; 48 ÷ 4 = 12; 48 − 24 − 12 = 12 минут.' },
    { id: 'logic-where-to-start', type: 'text', title: 'Задание 7 — Логика: с чего начать',
      prompt: 'С чего лучше начать: с самого сложного дела или с самого лёгкого? Почему? Ответь 1–3 предложениями.',
      ruPrimaryText: 'Логика порядка.', enHelpText: 'Logic order.', answer: 'Со сложного — пока много сил; с лёгкого — быстрая победа. Обе идеи ok.' },
    { id: 'spelling-day2', type: 'text', title: 'Задание 8 — Правописание',
      prompt: 'Напиши:\nработа\nрасписание\nчинить\nпорядок\nплан\n\nВставь буквы:\nраб_та\nрасп_сание\nчин_ть\nпор_док\nпл_н',
      ruPrimaryText: 'Правописание.', enHelpText: 'Spelling.', answer: 'работа, расписание, чинить, порядок, план.' },
    { id: 'creative-my-work-schedule', type: 'text', title: 'Задание 9 — Моё расписание работы',
      prompt: 'Составь мини-расписание из 4 дел:\nДело 1 (___ мин)\nДело 2 (___ мин)\nДело 3 (___ мин)\nДело 4 (___ мин)\nВсего: ______ мин.',
      ruPrimaryText: 'Творческий план.', enHelpText: 'Creative schedule.', answer: 'Список из 4 дел с временем и суммой.' },
    { id: 'speech-day2', type: 'text', title: 'Задание 10 — Объясни родителю',
      prompt: 'Скажи родителю по-русски:\nРасписание помогает не забыть дело.\nПорядок делает работу быстрее.\nМастер умеет чинить.',
      ruPrimaryText: 'Устное объяснение.', enHelpText: 'Explain to parent.', answer: 'Accept if in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова темы.',
    '2. Прочитай фразы.',
    '3. Реши задачи по шагам.',
    '4. Составь мини-расписание.',
    '5. Объясни родителю.'
  ],
  printWorksheet: {
    title: 'Работа и расписание / Work and Schedule',
    subtitle: 'Неделя 7 · День 2 / Week 7 · Day 2',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: Анита видит, как мастер планирует работу.' },
        { type: 'text', text: 'Задание 1 — Слова темы:' },
        { type: 'list', items: ['работа', 'расписание', 'чинить', 'порядок', 'план', 'время'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение. Отметь после чтения:' },
        { type: 'list', items: ['□ Мастер умеет чинить.', '□ Расписание помогает не забыть дело.', '□ Порядок делает работу быстрее.', '□ План — это шаги.'] },
        { type: 'text', text: 'Задание 3 — Мастер и 5 вещей. Реши по шагам:' },
        { type: 'text', text: 'Мастер чинит 5 вещей по 8 минут; ещё 10 минут на уборку.' },
        { type: 'list', items: ['8 × 5 = ______', '______ + 10 = ______'] },
        { type: 'text', text: 'Задание 4 — Расписание из 4 дел. Реши по шагам:' },
        { type: 'text', text: '4 дела: 6, 12, 25 и 7 минут. Час = 60 минут.' },
        { type: 'list', items: ['6 + 12 + 25 + 7 = ______', '60 − ______ = ______'] },
        { type: 'text', text: 'Задание 5 — 3 дня по 5 дел. Реши по шагам:' },
        { type: 'text', text: '2 утренних + 3 вечерних дела в день; всего 3 дня.' },
        { type: 'list', items: ['2 + 3 = ______ дел в день', '5 × 3 = ______ дел за 3 дня'] },
        { type: 'text', text: 'Задание 6 — 48 минут работы. Реши по шагам:' },
        { type: 'text', text: '48 минут: 1/2 — уборка, 1/4 — чтение, остальное — отдых.' },
        { type: 'list', items: ['48 ÷ 2 = ______ (уборка)', '48 ÷ 4 = ______ (чтение)', '48 − ______ − ______ = ______ (отдых)'] }
      ] },
      { title: 'Русский и защита / Russian and Defense', blocks: [
        { type: 'text', text: 'Задание 7 — Логика: с чего начать. Со сложного или с лёгкого? Ответь 1–3 предложениями.' },
        { type: 'text', text: 'Ответ: __________________________________________________________________' },
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['работа   расписание   чинить   порядок   план', 'раб_та   расп_сание   чин_ть   пор_док   пл_н'] },
        { type: 'text', text: 'Задание 9 — Моё расписание работы (мой проект дня, карточка расписания):' },
        { type: 'list', items: ['Дело 1: ____________________ (___ мин)', 'Дело 2: ____________________ (___ мин)', 'Дело 3: ____________________ (___ мин)', 'Дело 4: ____________________ (___ мин)', 'Всего: ______ мин'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю. Скажи по-русски:' },
        { type: 'list', items: ['□ Расписание помогает не забыть дело.', '□ Порядок делает работу быстрее.', '□ Мастер умеет чинить.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ math tasks  □ логика  □ правописание  □ расписание  □ объяснение.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицы в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    goal: 'Grade-3 математика + понимание расписания и порядка работы.',
    mathGoal: 'Умножение, деление, сложение, вычитание, дроби 1/2 и 1/4.',
    russianGoal: 'Прочитать 6 слов и 4 фразы, написать 5 слов.',
    readingWritingGoal: 'Мини-расписание + логическое рассуждение.',
    practicalGoal: 'Спланировать работу по шагам.',
    whatThisLessonTeaches: 'Расписание и порядок помогают быстрее и спокойнее выполнять работу.',
    keyMessage: 'Хороший план экономит время и силы.',
    howToExplain: 'Скажите: «Считаем шаги и складываем минуты».',
    exampleDialogue: 'Parent: Сколько минут всего?\nChild: 8 × 5 = 40, плюс 10 — 50.',
    readingSupport: 'Слово «расписание» читать по слогам.',
    russianSpeechGoal: 'Анита формулирует, как расписание помогает.',
    parentTheoryCard: {
      title: 'Как объяснить расписание',
      purpose: 'Показать, что расписание — это план, а не список требований.',
      keyMessage: 'Порядок делает работу быстрее.',
      parentScript: ['«Сначала считаем шаги.»', '«Потом смотрим общее время.»'],
      practiceSteps: ['Назовите дело.', 'Спросите: «Сколько минут?»', 'Попросите сложить.'],
      doNotSay: ['Не сравнивайте с «настоящими» рабочими днями взрослых.'],
      paperOnlyNotes: ['Все задания — на бумаге; никаких реальных заказов или клиентов.']
    },
    mathAnswerKey: 'master-5-things: 8 × 5 = 40; 40 + 10 = 50 минут. schedule-4-tasks: 6 + 12 + 25 + 7 = 50; 60 − 50 = 10 минут. three-days-5-tasks: 2 + 3 = 5; 5 × 3 = 15 дел. work-48-minutes: 48 ÷ 2 = 24; 48 ÷ 4 = 12; 48 − 24 − 12 = 12 минут.',
    spellingAnswerKey: 'работа\nрасписание\nчинить\nпорядок\nплан',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения фраз.' },
      { taskId: 'master-5-things', answer: '8 × 5 = 40; 40 + 10 = 50.' },
      { taskId: 'schedule-4-tasks', answer: '6 + 12 + 25 + 7 = 50; 60 − 50 = 10.' },
      { taskId: 'three-days-5-tasks', answer: '2 + 3 = 5; 5 × 3 = 15.' },
      { taskId: 'work-48-minutes', answer: '48 ÷ 2 = 24; 48 ÷ 4 = 12; 48 − 24 − 12 = 12.' },
      { taskId: 'logic-where-to-start', answer: 'Логическое рассуждение с обоснованием.' },
      { taskId: 'spelling-day2', answer: 'работа, расписание, чинить, порядок, план.' },
      { taskId: 'creative-my-work-schedule', answer: '4 дела и итоговая сумма.' },
      { taskId: 'speech-day2', answer: 'Устное объяснение по-русски.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита решила math tasks по шагам.',
      'Анита составила расписание.',
      'Анита объяснила родителю.'
    ],
    spellingCheck: 'Проверить: работа, расписание, чинить, порядок, план.',
    readingCheck: 'Попытка русского чтения важнее скорости.',
    practicalCheck: 'Расписание содержит 4 дела и сумму.',
    drawingCriteria: 'Расписание аккуратное и понятное.',
    commonMistakes: [
      '«Порядок неважен.» Правильно: «Порядок делает работу быстрее.»',
      '«Расписание = наказание.» Правильно: «Расписание помогает не забыть.»'
    ],
    discussionPrompts: [
      'Какое дело было бы первым?',
      'Как считать общее время?',
      'Когда план помогает?'
    ],
    ifEasy: 'Добавить 5-е дело в расписание и пересчитать сумму.',
    ifDifficult: 'Оставить 2 дела в расписании.',
    rewardGuidance: 'Базовая награда — 3 нима.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не обсуждаем реальные рабочие смены, зарплаты и наём. Всё — учебный план на бумаге.',
    safetyNotes: 'Не связываться с реальными заказчиками или работодателями. Задания только с родителем.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'clean-plan', label: 'Бонус за понятное расписание', amount: 1 },
      { id: 'clear-explain', label: 'Бонус за ясное объяснение', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'master-5-things', 'schedule-4-tasks', 'three-days-5-tasks', 'work-48-minutes', 'logic-where-to-start', 'spelling-day2', 'creative-my-work-schedule', 'speech-day2'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-7-day-3'
};

export default day2;
